<template>
  <div v-if="hubs.length > 0" class="landing_slider" :style="appConfig.isAvglDomain ? 'padding: 0; margin: 20px 0' : ''">
    <div v-if="!appConfig.isAvglDomain" class="landing_slider_title">
      <i class="sp-ic-sm-land-hub-icon" style="height: 22px" />
      Trending <b>Hubs</b>
    </div>
    <div v-else class="landing_slider_title">
      <b style="margin-left: 0">Trending Hubs</b>
    </div>
    <div id="view-hubs" ref="hub_slider" class="hub_container">
      <div v-for="hub in hubs" :key="hub.id" class="hub-card">
        <div class="card_wrap">
          <div class="label" />
          <a class="card_image" :href="routeUserLink(hub.alias)" :title="hub.name">
            <img
              class="lazyload"
              :data-src="hub.logo_url ? hub.logo_url : contentCloudFrontWithVersion('/avgl_default_event_icon.png')"
            >
          </a>
          <div class="card_properties">
            <div class="hub-name" :title="hub.name">
              <a :href="routeUserLink(hub.alias)">{{ hub.name }}</a>
            </div>
            <div v-if="getHubParticipants(hub) > 0" class="hub-info" style="color: var(--text-color)">
              {{ (getHubParticipants(hub) > 1 ? (getHubParticipants(hub) + ' members') : '1 member') + ' participating in events right now!' }}
            </div>
          </div>
          <a class="checkout_btn" :href="routeUserLink(hub.alias)" target="_blank">Check it out!</a>
        </div>
        <div class="total_member">{{ hub.count_members }} members</div>
      </div>
    </div>
    <!-- comment for issue GAME - 8754 -->
    <!-- <div v-if="checkLightTheme()" class="light-theme-slick-arrow">
      <div ref="arrow_prev" class="light_theme_arrow left" />
      <div ref="arrow_next" class="light_theme_arrow right" />
    </div> -->
  </div>
</template>

<script>
import { component } from '../../../mixins/component';
import { helper } from '../../../mixins/helper';
import { LandingAPI } from '../../../api/landing';
import Vue from 'vue';
import 'slick-carousel/slick/slick.min';
import jQuery from 'jquery';

const SLICK_RESPONSIVE_CONFIG_HUBS = [
  {
    breakpoint: 1500,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 1280,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 960,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
];

export default {
  mixins: [component, LandingAPI, helper],
  data() {
    return {
      hubs: [],
    };
  },
  created() {
    this.getTrendingHubs();
  },
  methods: {
    async getTrendingHubs() {
      const hubs = await this.getListTrendingHubAPI();
      const hubIds = {};
      this.hubs = hubs.filter(hub => {
        return hubIds[hub.id] ? false : (hubIds[hub.id] = true);
      });
      Vue.nextTick(() => {
        this.initSlick();
      });
    },
    initSlick() {
      // comment for issue GAME - 8754
      // if (this.checkLightTheme()) {
      //   jQuery(this.$refs.hub_slider).slick({
      //     infinite: false,
      //     speed: 300,
      //     slidesToShow: 6,
      //     slidesToScroll: 6,
      //     centerMode: false,
      //     variableWidth: true,
      //     initialSlide: 0,
      //     draggable: false,
      //     prevArrow: jQuery(this.$refs.arrow_prev),
      //     nextArrow: jQuery(this.$refs.arrow_next),
      //     responsive: SLICK_RESPONSIVE_CONFIG_HUBS,
      //   });
      // } else {
      jQuery(this.$refs.hub_slider).slick({
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
        initialSlide: 0,
        draggable: false,
        responsive: SLICK_RESPONSIVE_CONFIG_HUBS,
      });
      // }
    },
    getHubParticipants(hub) {
      let participants = hub.count_participants;
      if (hub.count_participants > hub.count_members) {
        participants = hub.count_members;
      }
      return participants;
    },
  },
};
</script>
